import React, {Component} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Row, UncontrolledTooltip} from "reactstrap";
import axios from "axios/index";
import {validateComponent, validateField} from "../../../common/validation";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import Table from "../../../components/Table/Table";
import {request} from "../../../helper/APIUtils";
import NotifyKS from "../../../components/NotifyKS";
import MaskedInput from "react-text-mask";
import createIBANMask from "text-mask-addon-iban";

class ExternalCustomerBankInfo extends Component {
	constructor(props) {
		super(props);

		this.state = {
			page: 0,
			size: 5,
			error: {},
			externalCustomerBank: {
				bankName: '',
				iban: ''
			},
			bankList: [],
			deleteModal: false,
			addBankModal: false,
			notify: null
		};

		this.validateField = this.validateField.bind(this);
		this.validateClass = this.validateClass.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.isChanged = this.isChanged.bind(this);
		this.updateBankList = this.updateBankList.bind(this);
		this.arrangeData = this.arrangeData.bind(this);
		this.cancelCurrentBank = this.cancelCurrentBank.bind(this);
	}

	componentDidMount() {
		this.setState({
			bankList: this.props.externalCustomerBankList
		})
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.externalCustomerBankList !== nextProps.externalCustomerBankList) {
			this.setState({
				bankList: nextProps.externalCustomerBankList
			})
		}
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	addBank() {
		this.props.addBankToCustomer();
		let error = deepCopyObject(this.state.error);
		if (error.tBankName.valid && error.tIban.valid) {
			this.setState({
				addBankModal: false
			})
		}
	}

	saveUpdatedBank() {
		let obj = this.props.externalCustomerBank;
		obj.externalCustomer = this.props.externalCustomer;
		axios.put('/externalCustomer/saveExternalCustomerBank', obj)
			.then(() => this.clearForm())
			.then(() => this.updateBankList(obj))
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	updateBankList(obj) {
		let bankList = JSON.parse(JSON.stringify(this.state.bankList));
		let selectedIndex = this.state.selectedIndex;
		bankList.splice(selectedIndex, 1, obj);
		this.setState({
			bankList: bankList
		})

	}

	handleEdit(data) {
		this.props.fillBankForm(data.original);
		this.openAddBankModal();
		this.setState({
			initExCustBankData: data.original,
			selectedIndex: data.index
		})
	}

	clearForm() {
		this.props.clearForm();
	}

	isChanged(initState, input) {
		if (JSON.stringify(initState) === JSON.stringify(input)) {
			return false
		} else {
			return true
		}
	}

	async removeBankFromBankListByIndex(id) {
		let bankList = this.state.bankList;
		let index = null;
		bankList.map((bank, i) => {
			if (bank.recordId === id) {
				index = i;
				console.log('hereeeee: %o', index)
			};
		});
		bankList.splice(index, 1);
		await this.setState({
			bankList
		})
	}

	async handleDelete(id) {
		let self = this;
		let params = {
			url: `/externalCustomer/deleteBankByRecordId`,
			method: 'post',
			data: id
		};
		request(params)
			.then(function (response) {
				self.removeBankFromBankListByIndex(id);
				self.setState({
					notify: {
						type: 'success',
						message: 'Banka kaydı başarıyla silindi'
					},
					deleteModal: false
				})
			})
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	handleRemove() {
		this.props.deleteBank(this.state.selectedRowId);
		let bankList = JSON.parse(JSON.stringify(this.state.bankList));
		bankList.splice(this.state.selectedRowIndex, 1);
		this.setState({bankList: bankList, deleteModal: false});
	}

	openDeleteModal(data) {
		this.setState({
			selectedRowId: data.recordId,
			selectedRowIndex: data.index,
			deleteModal: true
		})
	}

	openAddBankModal() {
		this.setState({
			addBankModal: true
		})
	}

	arrangeData(page, size) {
		this.setState({
			page: page,
			size: size,
			loading: false
		});
	}

	cancelCurrentBank() {
		this.setState({
			externalCustomerBank: {
				bankName: '',
				iban: ''
			},
			addBankModal: false
		})
	}

	render() {
		const columns = [
			{
				Header: "Banka Adı",
				accessor: "bankName"
			},
			{
				Header: "IBAN",
				accessor: "iban",
			},
			{
				Header: "",
				Cell: row => (
					<div>
						<button type="button" onClick={() => this.openDeleteModal(row)} rel="tooltip"
								className="btn btn-danger btn-icon btn-sm">
							<i className="now-ui-icons ui-1_simple-remove"/>
						</button>
					</div>
				)
			}
		];
		return (
			<div>

				{this.state.notify &&
				<Row>
					<NotifyKS
						type={this.state.notify.type}
						message={this.state.notify.message}
						html={this.state.notify.html}
						timeout={this.state.notify.timeout}
						autohide={this.state.notify.autohide}
					/>
				</Row>}

				<div className="row">
					<nav className="">
						<button type="button" data-toggle="tooltip" data-placement="bottom"
								style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', marginBottom: '10px', marginTop: '20px'}}
								rel="tooltip" className="TekBtn ekle "
								onClick={() => {
									this.openAddBankModal()
								}}>Yenİ Banka Ekle
						</button>
					</nav>
				</div>

				<div className="row">
					<Table
						columns={columns}
						content={this.state.bankList}
						page={this.state.page}
						options={["5", "10", "20", "50", "100"]}
						size={this.state.size}
						total={this.state.bankList.length}
						fetchData={this.arrangeData}
					/>
				</div>

				<Modal isOpen={this.state.addBankModal} size="lg">
					<ModalHeader toggle={this.cancelCurrentBank}>Yeni Hesap Bilgisi</ModalHeader>
					<ModalBody>
						<div className=" row">
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label className="col-form-label">Banka Adı</label>
								</div>
								<div className="col-sm-8" style={{maxWidth: "none"}}>
									<div className={"form-group" + this.validateClass('tBankName')}>
										<input className="form-control"
											   type="text"
											   name="bankName"
											   id="tBankName"
											   data-vlength="1,45"
											   data-vdata="bankName"
											   onBlur={this.validateField}
											   ref="tBankName"
											   value={this.props.externalCustomerBank && this.props.externalCustomerBank.bankName}
											   onChange={(e) => this.props.onChangeExternalCustomerBank(e)}/>
										{this.validateMessage('tBankName') !== "" &&
										<UncontrolledTooltip placement="right" target="tBankName" delay={0}>
											{this.validateMessage("tBankName")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>

							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label className="col-form-label">IBAN *</label>
								</div>
								<div className="col-sm-8" style={{maxWidth: "none"}}>
									<div className={"form-group" + this.validateClass('tIban')}>
										<MaskedInput className="form-control"
													 mask={createIBANMask('TR')}
													 placeholder={"TR__ ____ ____ ____ ____ ____ __"}
													 inputProps={{vdata: "iban", vlength: '1,45'}}
													 type="text"
													 name="iban"
													 id="tIban"
													 ref="tIban"
													 value={this.props.externalCustomerBank && this.props.externalCustomerBank.iban}
													 onBlur={this.validateField}
													 onChange={(e) => this.props.onChangeExternalCustomerBank(e)}/>
										{this.validateMessage('tIban') !== "" &&
										<UncontrolledTooltip placement="right" target="tIban" delay={0}>
											{this.validateMessage("tIban")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<nav className="row col-sm-12">
							<div className="col-3">
								<button type="button" data-toggle="tooltip" data-placement="bottom"
										style={{
											background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
											float: 'left',
											padding: '11px 45px 11px 13px'
										}}
										rel="tooltip" className="TekBtn vazgec "
										onClick={() => this.setState({
											addBankModal: false
										})}>İptal
								</button>
							</div>
							<div className="col-6"></div>
							<div className="col-3">
								<button type="button" data-toggle="tooltip" data-placement="bottom"
										style={{
											background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
											float: "right",
											padding: '11px 45px 11px 13px'
										}}
										rel="tooltip" className="TekBtn ekle  "
										onClick={() => this.addBank()}>Ekle
								</button>
							</div>
						</nav>
					</ModalFooter>
				</Modal>

				<Modal isOpen={this.state.deleteModal}>
					<ModalHeader toggle={this.toggle}>Emin misiniz ?</ModalHeader>
					<ModalBody>
						<Button color="primary"
								onClick={() => ((this.state.selectedRowId === '' || this.state.selectedRowId === null) ? this.handleRemove() : this.handleDelete(this.state.selectedRowId))}>Onayla</Button>
						<Button color="secondary" onClick={() => this.setState({
							deleteModal: false
						})}>İptal</Button>
					</ModalBody>
				</Modal>
			</div>
		)
	}
}

export default ExternalCustomerBankInfo;